module.exports = __webpack_public_path__ + "img/porsche-cim-logo.9bffd7e1.png";